"use client";
import React from "react";
import Link from "./webflow_modules/Basic/components/Link";

export function ButtonPrimaryWhite({
  link = {
    href: "#",
  },

  showButton = true,
  text = "search",
}) {
  return showButton ? (
    <Link button={true} className={"button-black-white-shrink"} options={link}>
      {text}
    </Link>
  ) : null;
}
